import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import DepartmentMain from "./DepartmentMain";
import Footer from "../../components/Footer";

const Departments = () => {
  return (
    <>
      <HeaderFour />
      <DepartmentMain />
      <Footer />
    </>
  );
};

export default Departments;
